var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('figure',{class:_vm.b('logo')},[_c('img',{attrs:{"src":_vm.$projectConfig.COMPANY_LOGO}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }